/**
 * @flow
 */

export function gotoMyTickets() {
  window.location.href = '/dashboard/tickets';
}

export function gotoCostItem(costItemId: string) {
  window.open(`/cost_items/${costItemId}.pdf`, '_blank');
}

export function gotoOrder(orderId: string) {
  window.location.href = `/dashboard/order/${orderId}`;
}

export function gotoTicket(ticketId: string) {
  window.location.href = `/dashboard/ticket/${ticketId}`;
}

export function gotoPaymentPlan(ticketId: string) {
  window.location.href = `/dashboard/payment-plans/${ticketId}`;
}

export function gotoTicketReceipt(ticketId: string) {
  window.open(`/tickets/${ticketId}.pdf`, '_blank');
}

export function gotoContactHost(hostId: string) {
  window.location.href = `/dashboard/conversations/withUser/${hostId}`;
}

export function gotoDownloadTicket(ticketId: string) {
  window.open(`/cost_items/${ticketId}.pdf`, '_blank');
}

export function gotoInvoice(invoiceId: string) {
  window.open(`/invoices/${invoiceId}.pdf`, '_blank');
}

export function gotoGenerateInvoice(ticketId: string) {
  window.location.href = `/dashboard/invoice/${ticketId}`;
}

export function gotoDashboardPage() {
  window.location.href = '/dashboard';
}

export function gotoReportsPage() {
  window.location.href = '/dashboard/reports';
}

export function gotoCreateNewReport() {
  window.location.href = '/dashboard/reports/create';
}

export function gotoEditReport(reportId: string) {
  window.location.href = `/dashboard/reports/edit/${reportId}`;
}

export function gotoBalanceDashboard(currency: string) {
  window.location.href = `${window.location.pathname.indexOf('/beta') == 0 ? '/beta' : ''}/dashboard/balance/${currency}`;
}



// WEBPACK FOOTER //
// ./src/lib/navigate-to.js